module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"TAX_ID":"CPF","PASSPORT":"Passaporte","documentType":{"TAX_ID":"CPF","PASSPORT":"Passaporte"}},"en":{"TAX_ID":"Tax ID","PASSPORT":"Passport","documentType":{"TAX_ID":"Tax ID","PASSPORT":"Passport"}}}')
  delete Component.options._Ctor
}
